import { Fragment, useState } from "react";
import {
  StyledAvatar,
  StyledCardContent,
  StyledCardHeader,
  StyledImgContainer,
  StyledTypographyContent,
  StyledCardActions,
} from "./NewsCard.style";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { FaRegCalendarAlt } from "react-icons/fa";
import parse from "html-react-parser";
import { IMG_BASE_URL } from "constants";
import { Link } from "react-router-dom";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function NewsCard(props) {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Fragment>
      {props.rows.map((row, index) => {
        return (
          <Grid
            item
            md={12}
            sm={12}
            mb={3}
            key={"row" + row.id}
            sx={{ width: "100% !important" }}
          >
            <Card sx={{ width: "100% !important", borderRadius: "15px" }}>
              <StyledCardContent>
                <Typography variant="body2">{row.title}</Typography>
              </StyledCardContent>
              <StyledCardHeader>
                <FaRegCalendarAlt />
                <span>{row.created_at?.string}</span>
              </StyledCardHeader>
              {row.file_type == "image" ? (
                <StyledImgContainer
                  isWeb
                  src={row?.file}
                  alt={"خبر"}
                  width="100%"
                  height="280px"
                  objectFit="cover"
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "280px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <video
                    src={IMG_BASE_URL + row?.file}
                    controls
                    style={{ height: "100%", margin: "auto", maxWidth: "95%" }}
                  ></video>
                </div>
              )}

              <CardContent>
                <StyledTypographyContent
                  style={{ textAlign: "justify", height: "70px" }}
                >
                  {parse(row.text)}
                </StyledTypographyContent>
              </CardContent>
              <StyledCardActions disableSpacing>
                <Link to={props.click(row.id)} target="_blank">
                  <Button variant="outlined" endIcon={<ArrowBackIosIcon />}>
                    ادامه خبر
                  </Button>
                </Link>
              </StyledCardActions>
            </Card>
          </Grid>
        );
      })}
    </Fragment>
  );
}
